<template>
  <!-- 原型 HTML 还原正文；顶/底由门户 PortalNavbar + PortalFooter 提供 -->
  <div class="sol-sb-daijia">
    <section class="hero" id="hero">
      <div class="container">
        <div class="hero-grid">
          <div class="hero-content reveal active">
            <div class="hero-badge">
              <span class="dot"></span>
              <span>已服务 500+ 代驾企业 · 覆盖 200+ 城市</span>
            </div>
            <h1>代驾管理解决方案<br><span class="highlight">智能调度安全出行</span>，降本增效品质升级</h1>
            <p class="hero-sub">整合司机管理、智能调度、行程安全、客户服务、财务结算全链路能力，为代驾企业提供一站式数字化运营管理平台，实现从接单到结算的全流程智能化。</p>
            <div class="hero-tags">
              <span>智能派单</span>
              <span>司机管理</span>
              <span>安全监控</span>
              <span>实时轨迹</span>
              <span>财务结算</span>
            </div>
            <div class="hero-cta">
              <button class="btn btn-primary btn-lg" @click="scrollToSection('cta')"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>立即预约演示</button>
            </div>
            <div class="hero-trust">
              <div class="hero-trust-item"><div><div class="hero-trust-num">500+</div><div class="hero-trust-label">服务代驾企业</div></div></div>
              <div class="hero-trust-divider"></div>
              <div class="hero-trust-item"><div><div class="hero-trust-num">99.9%</div><div class="hero-trust-label">系统可用性</div></div></div>
              <div class="hero-trust-divider"></div>
              <div class="hero-trust-item"><div><div class="hero-trust-num">7×24</div><div class="hero-trust-label">专属服务支持</div></div></div>
            </div>
          </div>
          <div class="hero-visual reveal reveal-delay-1 active">
            <div class="dash-mock">
              <div class="dash-bar">
                <div class="dots"><span></span><span></span><span></span></div>
                <div class="url">app.daijia-saas.com/dashboard</div>
              </div>
              <div class="dash-body">
                <div class="dash-side">
                  <div class="icon-item active"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="9"/><rect x="14" y="3" width="7" height="5"/><rect x="14" y="12" width="7" height="9"/><rect x="3" y="16" width="7" height="5"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3h18v18H3z"/><path d="M3 9h18M9 21V9"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 7L9 18l-5-5"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M4 22c0-4 4-7 8-7s8 3 8 7"/></svg></div>
                </div>
                <div class="dash-main">
                  <div class="dash-stats">
                    <div class="dash-stat">
                      <div class="dash-stat-label">今日订单</div>
                      <div class="dash-stat-val">2,856</div>
                      <div class="dash-stat-trend up">↑ 23.5%</div>
                    </div>
                    <div class="dash-stat">
                      <div class="dash-stat-label">在线司机</div>
                      <div class="dash-stat-val">1,420</div>
                      <div class="dash-stat-trend up">↑ 18.2%</div>
                    </div>
                    <div class="dash-stat">
                      <div class="dash-stat-label">平均响应</div>
                      <div class="dash-stat-val">3.2min</div>
                      <div class="dash-stat-trend up">↓ 16.8%</div>
                    </div>
                  </div>
                  <div class="dash-chart">
                    <div class="dash-chart-head">
                      <div class="dash-chart-title">全天订单趋势</div>
                      <div class="dash-chart-tag">今日实时</div>
                    </div>
                    <div class="bars">
                      <div class="bar" style="height:45%"></div>
                      <div class="bar" style="height:62%"></div>
                      <div class="bar dim" style="height:38%"></div>
                      <div class="bar" style="height:75%"></div>
                      <div class="bar" style="height:88%"></div>
                      <div class="bar" style="height:55%"></div>
                      <div class="bar" style="height:95%"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="dash-float dash-float-1">
              <div class="dash-float-icon green">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg>
              </div>
              <div class="dash-float-text">
                <div class="num">智能调度</div>
                <div class="label">秒级匹配最近司机</div>
              </div>
            </div>
            <div class="dash-float dash-float-2">
              <div class="dash-float-icon blue">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
              </div>
              <div class="dash-float-text">
                <div class="num">派单提效 60%+</div>
                <div class="label">AI智能调度引擎</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section pain-section" id="pain">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">01 PAIN POINTS</div>
          <h2 class="section-title">行业现状与经营痛点</h2>
          <p class="section-subtitle">传统代驾经营模式存在接单调度难、司机管理散、安全监控弱等诸多难题，严重制约代驾企业规模化发展</p>
        </div>
        <div class="pain-grid">
          <div class="pain-card reveal">
            <div class="pain-num">01</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 12a9 9 0 11-6.219-8.56"/><path d="M22 4L12 14.01l-3-3"/></svg>
            </div>
            <h3 class="pain-title">接单调度效率低</h3>
            <p class="pain-desc">传统电话派单模式响应慢、错单率高，高峰期司机资源无法智能匹配运力需求，客户等待时间长、体验差。</p>
          </div>
          <div class="pain-card reveal reveal-delay-1">
            <div class="pain-num">02</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
            </div>
            <h3 class="pain-title">司机管理碎片化</h3>
            <p class="pain-desc">司机资质审核、排班调度、绩效考核依赖人工台账，信息分散不透明，无法实现统一精细化管理。</p>
          </div>
          <div class="pain-card reveal reveal-delay-2">
            <div class="pain-num">03</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            </div>
            <h3 class="pain-title">安全监控薄弱</h3>
            <p class="pain-desc">缺乏实时行车轨迹追踪、异常行为预警机制，安全事故难追溯，保险理赔流程复杂低效。</p>
          </div>
          <div class="pain-card reveal">
            <div class="pain-num">04</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
            </div>
            <h3 class="pain-title">客户体验单一</h3>
            <p class="pain-desc">缺少端到端的线上服务闭环，预约、支付、评价流程断裂，无法沉淀客户数据用于精准营销。</p>
          </div>
          <div class="pain-card reveal reveal-delay-1">
            <div class="pain-num">05</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>
            </div>
            <h3 class="pain-title">财务结算混乱</h3>
            <p class="pain-desc">多渠道计费规则不统一，司机分账、平台佣金结算依赖人工核算，对账误差频繁。</p>
          </div>
          <div class="pain-card reveal reveal-delay-2">
            <div class="pain-num">06</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 3v18h18"/><path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14"/></svg>
            </div>
            <h3 class="pain-title">数据决策缺失</h3>
            <p class="pain-desc">运营数据散落各处，无统一可视化看板，无法基于数据优化运力配置与定价策略。</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section solution-section" id="solution">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">02 SOLUTION OVERVIEW</div>
          <h2 class="section-title">解决方案总览</h2>
          <p class="section-subtitle">专为代驾企业打造的一体化SaaS数字化管理平台，全方位解决代驾行业经营痛点</p>
        </div>
        <div class="solution-grid">
          <div class="solution-card reveal">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><path d="M9 22V12h6v10"/></svg>
            </div>
            <h3>方案简介</h3>
            <p>整合司机管理、智能调度、行程安全、客户服务、财务结算全链路能力，为代驾企业提供一站式数字化运营管理平台，实现从接单到结算的全流程智能化。</p>
          </div>
          <div class="solution-card reveal reveal-delay-1">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/><path d="M2 12h20"/></svg>
            </div>
            <h3>方案目标</h3>
            <p>实现接单自动化调度、司机全生命周期管理、行程安全实时监控、财务自动结算，助力代驾企业降本增效、提升服务品质与客户满意度。</p>
          </div>
          <div class="solution-card reveal reveal-delay-2">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
            </div>
            <h3>适用对象</h3>
            <p>专业代驾公司、出行平台代驾业务线、汽车服务连锁企业、酒后代驾服务商。</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section func-section" id="features">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">03 CORE MODULES</div>
          <h2 class="section-title">核心功能模块</h2>
          <p class="section-subtitle">全链路数字化功能矩阵，覆盖代驾经营全场景，一站式解决经营管理难题</p>
        </div>
        <div class="func-grid">
          <div class="func-card reveal">
            <div class="func-card-num">01</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
              </div>
              <h3>智能派单调度系统</h3>
              <p>基于LBS实时定位、司机状态、客户位置等多维算法自动匹配最优司机，支持抢单+派单双模式，高峰期智能运力调配。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-1">
            <div class="func-card-num">02</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
              </div>
              <h3>司机全生命周期管理</h3>
              <p>覆盖司机招募、资质审核、培训认证、排班考勤、绩效考核、奖惩管理全流程，一人一档数字化管理。</p>
            </div>
          </div>
          <div class="func-card reveal">
            <div class="func-card-num">03</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              </div>
              <h3>实时行程安全监控</h3>
              <p>全程GPS轨迹追踪、异常停留/偏航预警、一键报警联动、行车录音留存，全方位保障司乘安全。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-1">
            <div class="func-card-num">04</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>
              </div>
              <h3>客户端全流程服务</h3>
              <p>支持小程序/H5/APP多端预约代驾，实时查看司机位置、预估费用、在线支付、服务评价，打造极致客户体验。</p>
            </div>
          </div>
          <div class="func-card reveal">
            <div class="func-card-num">05</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 10h20"/></svg>
              </div>
              <h3>智能计费与结算中心</h3>
              <p>支持按时长、里程、时段、车型等多维度灵活定价，自动计算司机分账与平台佣金，实时生成结算报表。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-1">
            <div class="func-card-num">06</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
              </div>
              <h3>保险理赔数字化</h3>
              <p>对接保险服务商，支持在线报案、定损、理赔进度跟踪，大幅缩短理赔周期，降低运营风险。</p>
            </div>
          </div>
          <div class="func-card reveal">
            <div class="func-card-num">07</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3v18h18"/><path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14"/></svg>
              </div>
              <h3>数据驾驶舱</h3>
              <p>实时展示订单量、完单率、司机在线率、客户满意度等核心指标，支持多维度数据分析与趋势预测。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-1">
            <div class="func-card-num">08</div>
            <div class="func-card-body">
              <div class="func-card-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
              </div>
              <h3>客户运营与营销</h3>
              <p>会员分级、优惠券发放、积分商城、老客推荐奖励等营销工具，提升客户粘性与复购率。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section advantage-section" id="advantage">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">04 CORE ADVANTAGES</div>
          <h2 class="section-title">方案核心优势</h2>
          <p class="section-subtitle">区别于传统代驾系统，依托AI智能调度引擎与一体化SaaS平台优势，为企业提供全链路数字化解决方案</p>
        </div>
        <div class="advantage-grid">
          <div class="advantage-card reveal">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
            </div>
            <h3>AI智能调度引擎</h3>
            <p>自研AI调度算法，毫秒级匹配最优司机，派单效率提升60%以上，客户平均等待时间缩短40%。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-1">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            </div>
            <h3>五重安全防护体系</h3>
            <p>实名认证、轨迹追踪、异常预警、一键报警、保险托底五重安全防护机制，全方位保障司乘安全。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-2">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>
            </div>
            <h3>全终端覆盖</h3>
            <p>支持司机端APP、客户小程序/H5、管理后台PC端三端协同，数据实时同步，随时随地高效管理。</p>
          </div>
          <div class="advantage-card reveal">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg>
            </div>
            <h3>灵活定价引擎</h3>
            <p>支持峰谷定价、区域定价、车型定价等多维度计费策略，适配各类商业模式与市场策略。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-1">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
            </div>
            <h3>开放生态对接</h3>
            <p>无缝对接主流地图服务、支付渠道、保险公司、第三方出行平台，构建完整代驾服务生态。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-2">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 7L9 18l-5-5"/></svg>
            </div>
            <h3>企业级权限管理</h3>
            <p>精细化角色权限分级，支持城市分公司、区域代理商多层级管理，数据隔离、运营独立。</p>
          </div>
          <div class="advantage-card reveal">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </div>
            <h3>极速部署上线</h3>
            <p>SaaS轻量化模式，开通即用，无需自建服务器与运维团队，3天内完成部署上线。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-1">
            <div class="advantage-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>
            </div>
            <h3>专属运营陪跑</h3>
            <p>提供行业运营顾问一对一服务，从业务诊断、方案落地到持续优化全程护航。</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section scenario-section" id="scenario">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">05 USE CASES</div>
          <h2 class="section-title">典型应用场景</h2>
          <p class="section-subtitle">贴合代驾行业全场景经营需求，全方位适配企业日常运营与拓客增收场景</p>
        </div>
        <div class="scenario-grid">
          <div class="scenario-card reveal">
            <div class="scenario-tag">场景 01</div>
            <h3>酒后代驾服务</h3>
            <p>与餐饮商家合作引流，客户扫码一键叫代驾，高峰期智能调度保障运力。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-1">
            <div class="scenario-tag">场景 02</div>
            <h3>商务代驾出行</h3>
            <p>支持企业签约客户专属服务，月结账单、VIP司机优选、行程报告推送。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-2">
            <div class="scenario-tag">场景 03</div>
            <h3>车辆送修/取送</h3>
            <p>对接4S店与维修厂，提供车辆送修代驾、维修完毕送回一站式服务。</p>
          </div>
          <div class="scenario-card reveal">
            <div class="scenario-tag">场景 04</div>
            <h3>长途代驾</h3>
            <p>支持跨城长途代驾订单，分段计费、行程安全监控、疲劳驾驶预警。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-1">
            <div class="scenario-tag">场景 05</div>
            <h3>大型活动保障</h3>
            <p>演唱会、体育赛事等大型活动散场高峰期运力保障，智能预估需求、提前调度。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-2">
            <div class="scenario-tag">场景 06</div>
            <h3>政企合作服务</h3>
            <p>为政府公务出行、企业差旅提供合规代驾服务，统一结算、票据电子化。</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section value-section" id="value">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">06 CUSTOMER VALUE</div>
          <h2 class="section-title">客户落地价值</h2>
          <p class="section-subtitle">量化数字化转型成果，实实在在为代驾企业降本、增效、提升服务品质</p>
        </div>
        <div class="value-grid">
          <div class="value-card reveal">
            <div class="value-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
            </div>
            <h3>运营效率大幅提升</h3>
            <p>智能调度替代人工派单，订单处理效率提升80%，人力成本降低50%以上。</p>
            <div class="value-highlight">成本降低 50%</div>
          </div>
          <div class="value-card reveal reveal-delay-1">
            <div class="value-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            </div>
            <h3>安全事故有效降低</h3>
            <p>全程安全监控体系，事故发生率降低70%，保险理赔周期从30天缩短至7天。</p>
            <div class="value-highlight">事故率 ↓70%</div>
          </div>
          <div class="value-card reveal reveal-delay-2">
            <div class="value-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3v18h18"/><path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14"/></svg>
            </div>
            <h3>客户满意度显著增长</h3>
            <p>端到端数字化体验，客户等待时间缩短40%，好评率提升至95%以上。</p>
            <div class="value-highlight">好评率 95%+</div>
          </div>
          <div class="value-card reveal reveal-delay-3">
            <div class="value-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>
            </div>
            <h3>科学化经营决策</h3>
            <p>全维度数据分析看板，基于数据优化定价、运力与市场策略，决策效率提升80%。</p>
            <div class="value-highlight">决策效率 80%↑</div>
          </div>
        </div>
      </div>
    </section>

    <section class="trust-section" id="trust">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">07 TRUST & RECOGNITION</div>
          <h2 class="section-title">品牌信任背书</h2>
          <p class="section-subtitle">500+ 代驾企业的共同选择，权威认证护航，生态合作共建数字化未来</p>
        </div>
        <div class="trust-stats reveal">
          <div class="trust-stat">
            <div class="num">500<span class="unit">+</span></div>
            <div class="label">服务代驾企业</div>
          </div>
          <div class="trust-stat">
            <div class="num">200<span class="unit">+</span></div>
            <div class="label">覆盖城市</div>
          </div>
          <div class="trust-stat">
            <div class="num">99.9<span class="unit">%</span></div>
            <div class="label">系统可用性</div>
          </div>
          <div class="trust-stat">
            <div class="num">7×24</div>
            <div class="label">专属服务</div>
          </div>
        </div>
        <div class="logo-wall reveal">
          <div class="logo-wall-title">TRUSTED BY LEADING BRANDS</div>
          <div class="logo-grid">
            <div class="logo-item">e代驾</div>
            <div class="logo-item">滴滴代驾</div>
            <div class="logo-item">安师傅</div>
            <div class="logo-item">代驾帮</div>
            <div class="logo-item">微代驾</div>
            <div class="logo-item">爱代驾</div>
            <div class="logo-item">神州代驾</div>
            <div class="logo-item">曹操代驾</div>
            <div class="logo-item">享代驾</div>
            <div class="logo-item">顺风代驾</div>
            <div class="logo-item">优享代驾</div>
            <div class="logo-item">无忧代驾</div>
          </div>
        </div>
        <div class="trust-cert reveal">
          <div class="cert-card">
            <div class="cert-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
            </div>
            <div class="cert-info">
              <div class="title">ISO 27001 信息安全认证</div>
              <div class="desc">国际权威信息安全管理体系认证</div>
            </div>
          </div>
          <div class="cert-card">
            <div class="cert-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 12l2 2 4-4"/><path d="M3 9h18"/></svg>
            </div>
            <div class="cert-info">
              <div class="title">等保三级认证</div>
              <div class="desc">国家信息安全等级保护三级资质</div>
            </div>
          </div>
          <div class="cert-card">
            <div class="cert-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7v10l10 5 10-5V7L12 2z"/><path d="M2 7l10 5 10-5M12 22V12"/></svg>
            </div>
            <div class="cert-info">
              <div class="title">高新技术企业</div>
              <div class="desc">国家级高新技术企业资质认证</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section faq-section" id="faq">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">08 FAQ</div>
          <h2 class="section-title">常见问题</h2>
          <p class="section-subtitle">解答用户高频疑问，打消合作顾虑</p>
        </div>
        <div class="faq-wrap reveal">
          <div class="faq-item">
            <div class="faq-q">
              <span>系统是否支持与现有调度系统对接？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">系统提供标准API接口，可无缝对接现有业务系统、地图服务与支付平台，支持数据互通与功能互补。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>司机端APP是否支持离线使用？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">支持关键功能离线操作，网络恢复后自动同步数据，确保在弱网环境下正常服务。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>如何处理高峰期运力不足问题？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">系统支持智能预估需求、跨区域调度、临时司机快速注册上线等机制，有效应对高峰期运力挑战。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>数据安全性如何保障？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">通过等保三级认证，数据传输加密、权限分级管控、异地灾备，确保司乘数据绝对安全。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>收费模式是怎样的？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">按需订阅付费，根据司机数量与功能需求灵活选择套餐，支持按月/按年付费，无隐形消费。</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-section" id="cta">
      <div class="container">
        <div class="cta-inner reveal">
          <h2>助力代驾企业<span class="highlight">数字化转型升级</span></h2>
          <p>智慧出行一体化运营，降本增效、安全护航，开启代驾数字化新征程</p>
          <div class="cta-options">
              <a class="btn btn-primary btn-lg" href="#" role="button" @click.prevent="openCustomerService">咨询详情</a>
            </div>
          <div class="cta-note">
            <span>7×24小时技术支持</span>
            <span class="dot"></span>
            <span>一对一专属服务</span>
            <span class="dot"></span>
            <span>免费落地培训指导</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { openCustomerService } from '../../openCustomerService'
defineOptions({ name: 'PortalSbDaijia' })

let revealIo: IntersectionObserver | null = null

function scrollToSection(id: string) {
  const el = document.getElementById(id)
  if (!el) return
  const scroller = document.querySelector('.portal-page') as HTMLElement | null
  if (scroller) {
    const top =
      el.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - 12
    scroller.scrollTo({ top, behavior: 'smooth' })
    return
  }
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 72, behavior: 'smooth' })
}

function bindFaq() {
  const rootEl = document.querySelector('.sol-sb-daijia')
  if (!rootEl) return
  rootEl.querySelectorAll('.faq-item').forEach((item) => {
    const q = item.querySelector('.faq-q') as HTMLElement | null
    const a = item.querySelector('.faq-a') as HTMLElement | null
    if (!q || !a) return
    a.style.maxHeight = '0'
    q.onclick = () => {
      const isActive = item.classList.contains('active')
      rootEl.querySelectorAll('.faq-item').forEach((other) => {
        other.classList.remove('active')
        const oa = other.querySelector('.faq-a') as HTMLElement | null
        if (oa) oa.style.maxHeight = '0'
      })
      if (!isActive) {
        item.classList.add('active')
        a.style.maxHeight = a.scrollHeight + 'px'
      }
    }
  })
}

function bindReveal() {
  const nodes = document.querySelectorAll('.sol-sb-daijia .reveal')
  revealIo = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add('active')
      })
    },
    { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
  )
  nodes.forEach((n) => revealIo!.observe(n))
}

function bindBars() {
  const bars = document.querySelectorAll('.sol-sb-daijia .bars .bar')
  bars.forEach((bar, i) => {
    const el = bar as HTMLElement
    const h = el.style.height
    if (!h) return
    el.style.height = '0'
    window.setTimeout(() => {
      el.style.transition = `height .8s ease ${i * 0.08}s`
      el.style.height = h
    }, 100)
  })
}

onMounted(() => {
  bindFaq()
  bindReveal()
  bindBars()
})

onBeforeUnmount(() => {
  revealIo?.disconnect()
  revealIo = null
})
</script>

<style lang="scss">

.sol-sb-daijia,.sol-sb-daijia *,.sol-sb-daijia *::before,.sol-sb-daijia *::after{margin:0;padding:0;box-sizing:border-box}
.sol-sb-daijia{
  --c-primary:#1e88e5;
  --c-primary-2:#1976d2;
  --c-primary-3:#1565c0;
  --c-primary-4:#0d47a1;
  --c-primary-light:#42a5f5;
  --c-primary-bright:#2196f3;
  --c-cyan:#06b6d4;
  --c-slate:#475569;
  --c-slate-light:#64748b;
  --c-text:#0f172a;
  --c-text-mid:#334155;
  --c-bg:#f5f9ff;
  --c-bg-2:#eef4fc;
  --c-bg-3:#e8f1fb;
  --c-border:#e2e8f0;
  --c-white:#fff;
  --c-footer:#0a1929;
  --c-footer-2:#0d2238;
  --radius:14px;
  --radius-lg:22px;
  --shadow-sm:0 2px 8px rgba(30,136,229,.08);
  --shadow:0 8px 28px rgba(30,136,229,.10);
  --shadow-lg:0 18px 56px rgba(30,136,229,.14);
  --shadow-xl:0 28px 80px rgba(30,136,229,.18);
  --shadow-blue:0 10px 30px rgba(30,136,229,.35);
  --max-w:1280px;
  --font:-apple-system,BlinkMacSystemFont,"Segoe UI","PingFang SC","Hiragino Sans GB","Microsoft YaHei",sans-serif;
}
.sol-sb-daijia{scroll-behavior:smooth;font-size:16px}
.sol-sb-daijia{font-family:var(--font);color:var(--c-text);background:var(--c-white);line-height:1.7;overflow-x:hidden;-webkit-font-smoothing:antialiased}
.sol-sb-daijia a{text-decoration:none;color:inherit}
.sol-sb-daijia img{max-width:100%;display:block}
.sol-sb-daijia ul{list-style:none}
.sol-sb-daijia .container{max-width:var(--max-w);margin:0 auto;padding:0 24px}
.sol-sb-daijia .section{padding:110px 0;position:relative}
.sol-sb-daijia .section-sm{padding:72px 0}

.sol-sb-daijia .eyebrow{font-size:.8rem;font-weight:700;letter-spacing:.2em;text-transform:uppercase;color:var(--c-primary);margin-bottom:12px}
.sol-sb-daijia .section-num{font-size:.82rem;font-weight:800;letter-spacing:.18em;color:var(--c-primary);display:inline-block;background:linear-gradient(135deg,rgba(30,136,229,.1),rgba(66,165,245,.1));padding:6px 14px;border-radius:100px;margin-bottom:14px}
.sol-sb-daijia .section-title{font-size:2.4rem;font-weight:800;color:var(--c-text);line-height:1.25;margin-bottom:18px;letter-spacing:-.02em}
.sol-sb-daijia .section-subtitle{font-size:1.08rem;color:var(--c-slate);max-width:720px;line-height:1.8}
.sol-sb-daijia .section-head{margin-bottom:64px}
.sol-sb-daijia .section-head.center{text-align:center}
.sol-sb-daijia .section-head.center .section-subtitle{margin:0 auto}
.sol-sb-daijia .section-head.center .section-num{display:inline-block}

.sol-sb-daijia .header{position:fixed;top:0;left:0;right:0;z-index:1000;background:rgba(255,255,255,.97);backdrop-filter:blur(16px);border-bottom:1px solid var(--c-border);transition:box-shadow .3s}
.sol-sb-daijia .header.scrolled{box-shadow:0 4px 20px rgba(30,136,229,.08)}
.sol-sb-daijia .header-inner{display:flex;align-items:center;justify-content:space-between;height:72px;max-width:var(--max-w);margin:0 auto;padding:0 24px}
.sol-sb-daijia .logo{display:flex;align-items:center;gap:12px;font-size:1.3rem;font-weight:800;color:var(--c-primary-3);letter-spacing:-.02em}
.sol-sb-daijia .logo svg{width:36px;height:36px;flex-shrink:0}
.sol-sb-daijia .nav{display:flex;align-items:center;gap:36px}
.sol-sb-daijia .nav a{font-size:.94rem;color:var(--c-text-mid);font-weight:500;transition:color .2s;position:relative}
.sol-sb-daijia .nav a:hover{color:var(--c-primary)}
.sol-sb-daijia .nav a::after{content:"";position:absolute;bottom:-6px;left:0;width:0;height:2.5px;background:var(--c-primary);border-radius:2px;transition:width .25s}
.sol-sb-daijia .nav a:hover::after{width:100%}
.sol-sb-daijia .header-cta{display:flex;align-items:center;gap:14px}

.sol-sb-daijia .btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;padding:12px 28px;border-radius:12px;font-size:.94rem;font-weight:600;cursor:pointer;border:none;transition:all .25s;white-space:nowrap;line-height:1.2}
.sol-sb-daijia .btn-primary{background:linear-gradient(180deg,#42a5f5 0%,#1e88e5 50%,#1976d2 100%);color:#fff;box-shadow:inset 0 1px 0 rgba(255,255,255,.4),inset 0 -2px 0 rgba(0,0,0,.08),0 4px 0 var(--c-primary-3),0 8px 20px rgba(30,136,229,.35)}
.sol-sb-daijia .btn-primary:hover{transform:translateY(-2px);box-shadow:inset 0 1px 0 rgba(255,255,255,.4),inset 0 -2px 0 rgba(0,0,0,.08),0 6px 0 var(--c-primary-3),0 12px 26px rgba(30,136,229,.45)}
.sol-sb-daijia .btn-primary:active{transform:translateY(2px);box-shadow:inset 0 1px 0 rgba(255,255,255,.4),inset 0 -2px 0 rgba(0,0,0,.08),0 1px 0 var(--c-primary-3),0 4px 12px rgba(30,136,229,.35)}
.sol-sb-daijia .btn-outline{background:#fff;color:var(--c-primary-3);border:1.5px solid var(--c-border);box-shadow:0 4px 12px rgba(30,136,229,.08)}
.sol-sb-daijia .btn-outline:hover{border-color:var(--c-primary);color:var(--c-primary);box-shadow:0 6px 18px rgba(30,136,229,.18);transform:translateY(-2px)}
.sol-sb-daijia .btn-ghost{background:rgba(255,255,255,.14);color:#fff;border:1px solid rgba(255,255,255,.35);backdrop-filter:blur(6px)}
.sol-sb-daijia .btn-ghost:hover{background:rgba(255,255,255,.24);transform:translateY(-2px)}
.sol-sb-daijia .btn-lg{padding:17px 40px;font-size:1.05rem;border-radius:14px}
.sol-sb-daijia .btn-lg.btn-primary{box-shadow:inset 0 1px 0 rgba(255,255,255,.45),inset 0 -2px 0 rgba(0,0,0,.1),0 6px 0 var(--c-primary-3),0 12px 28px rgba(30,136,229,.4)}
.sol-sb-daijia .btn-sm{padding:9px 20px;font-size:.85rem;border-radius:10px}
.sol-sb-daijia .menu-toggle{display:none;flex-direction:column;gap:5px;cursor:pointer;padding:6px;background:none;border:none}
.sol-sb-daijia .menu-toggle span{width:24px;height:2.5px;background:var(--c-primary-3);border-radius:2px;transition:.3s}
.sol-sb-daijia .menu-toggle.active span:nth-child(1){transform:translateY(7.5px) rotate(45deg)}
.sol-sb-daijia .menu-toggle.active span:nth-child(2){opacity:0}
.sol-sb-daijia .menu-toggle.active span:nth-child(3){transform:translateY(-7.5px) rotate(-45deg)}

.sol-sb-daijia .hero{position:relative;background:linear-gradient(135deg,#0d47a1 0%,#1565c0 30%,#1e88e5 70%,#2196f3 100%);padding:150px 0 100px;overflow:hidden}
.sol-sb-daijia .hero::before{content:"";position:absolute;top:0;left:0;right:0;bottom:0;background-image:radial-gradient(circle at 15% 40%,rgba(255,255,255,.18) 0%,transparent 45%),radial-gradient(circle at 85% 25%,rgba(66,165,245,.25) 0%,transparent 50%),radial-gradient(circle at 70% 80%,rgba(255,255,255,.1) 0%,transparent 40%);pointer-events:none}
.sol-sb-daijia .hero::after{content:"";position:absolute;bottom:-1px;left:0;right:0;height:80px;background:linear-gradient(to bottom,transparent,var(--c-white));pointer-events:none}
.sol-sb-daijia .hero-grid{display:grid;grid-template-columns:1.1fr .9fr;gap:56px;align-items:center;position:relative;z-index:1}
.sol-sb-daijia .hero-badge{display:inline-flex;align-items:center;gap:10px;padding:8px 18px;background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.25);border-radius:100px;color:#fff;font-size:.82rem;font-weight:500;margin-bottom:30px;backdrop-filter:blur(8px)}
.sol-sb-daijia .hero-badge .dot{width:8px;height:8px;background:#34d399;border-radius:50%;box-shadow:0 0 10px #34d399;animation:pulse 1.6s ease-in-out infinite}
@keyframes pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.6;transform:scale(1.3)}}
.sol-sb-daijia .hero h1{font-size:3.2rem;font-weight:900;color:#fff;line-height:1.18;letter-spacing:-.025em;margin-bottom:24px}
.sol-sb-daijia .hero h1 .highlight{background:linear-gradient(135deg,#fff,#bbdefb);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;position:relative;display:inline-block}
.sol-sb-daijia .hero h1 .highlight::after{content:"";position:absolute;left:0;right:0;bottom:-4px;height:6px;background:linear-gradient(90deg,#fff 0%,rgba(255,255,255,.2) 100%);border-radius:3px;opacity:.5}
.sol-sb-daijia .hero-sub{font-size:1.14rem;color:rgba(255,255,255,.85);line-height:1.85;margin-bottom:28px;max-width:560px}
.sol-sb-daijia .hero-tags{display:flex;flex-wrap:wrap;gap:10px;margin-bottom:36px}
.sol-sb-daijia .hero-tags span{padding:7px 16px;border:1px solid rgba(255,255,255,.3);border-radius:30px;font-size:.8rem;color:rgba(255,255,255,.85);background:rgba(255,255,255,.06);backdrop-filter:blur(4px)}
.sol-sb-daijia .hero-cta{display:flex;gap:16px;margin-bottom:40px;flex-wrap:wrap}
.sol-sb-daijia .hero-trust{display:flex;align-items:center;gap:30px;flex-wrap:wrap}
.sol-sb-daijia .hero-trust-item{display:flex;align-items:center;gap:10px}
.sol-sb-daijia .hero-trust-num{font-size:1.65rem;font-weight:800;color:#fff}
.sol-sb-daijia .hero-trust-label{font-size:.82rem;color:rgba(255,255,255,.6)}
.sol-sb-daijia .hero-trust-divider{width:1px;height:40px;background:rgba(255,255,255,.18)}

.sol-sb-daijia .hero-visual{position:relative}
.sol-sb-daijia .dash-mock{background:#fff;border-radius:18px;box-shadow:0 40px 90px rgba(0,30,80,.45);overflow:hidden;border:1px solid rgba(255,255,255,.2)}
.sol-sb-daijia .dash-bar{display:flex;align-items:center;gap:8px;padding:14px 18px;background:#f0f7ff;border-bottom:1px solid var(--c-border)}
.sol-sb-daijia .dash-bar .dots{display:flex;gap:6px}
.sol-sb-daijia .dash-bar .dots span{width:10px;height:10px;border-radius:50%}
.sol-sb-daijia .dash-bar .dots span:nth-child(1){background:#ef4444}
.sol-sb-daijia .dash-bar .dots span:nth-child(2){background:#f59e0b}
.sol-sb-daijia .dash-bar .dots span:nth-child(3){background:#22c55e}
.sol-sb-daijia .dash-bar .url{flex:1;text-align:center;font-size:.72rem;color:var(--c-slate-light);background:#fff;border:1px solid var(--c-border);border-radius:6px;padding:4px 14px;margin-left:8px}
.sol-sb-daijia .dash-body{display:grid;grid-template-columns:68px 1fr;min-height:360px}
.sol-sb-daijia .dash-side{background:linear-gradient(180deg,#0d47a1,#1565c0);padding:16px 0;display:flex;flex-direction:column;align-items:center;gap:16px}
.sol-sb-daijia .dash-side .icon-item{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;color:rgba(255,255,255,.5);transition:.2s}
.sol-sb-daijia .dash-side .icon-item.active{background:linear-gradient(135deg,#42a5f5,#1e88e5);color:#fff;box-shadow:0 4px 12px rgba(30,136,229,.5)}
.sol-sb-daijia .dash-side .icon-item svg{width:18px;height:18px}
.sol-sb-daijia .dash-main{padding:20px;background:#fafbfc}
.sol-sb-daijia .dash-stats{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:16px}
.sol-sb-daijia .dash-stat{background:#fff;border:1px solid var(--c-border);border-radius:12px;padding:14px;transition:.2s}
.sol-sb-daijia .dash-stat:hover{border-color:var(--c-primary-light);box-shadow:0 4px 12px rgba(30,136,229,.1)}
.sol-sb-daijia .dash-stat-label{font-size:.68rem;color:var(--c-slate-light);margin-bottom:4px}
.sol-sb-daijia .dash-stat-val{font-size:1.2rem;font-weight:800;color:var(--c-text)}
.sol-sb-daijia .dash-stat-trend{font-size:.65rem;font-weight:700;margin-top:3px}
.sol-sb-daijia .up{color:#10b981}
.sol-sb-daijia .dn{color:#ef4444}
.sol-sb-daijia .dash-chart{background:#fff;border:1px solid var(--c-border);border-radius:12px;padding:16px}
.sol-sb-daijia .dash-chart-head{display:flex;justify-content:space-between;align-items:center;margin-bottom:14px}
.sol-sb-daijia .dash-chart-title{font-size:.74rem;font-weight:600;color:var(--c-text)}
.sol-sb-daijia .dash-chart-tag{font-size:.62rem;color:var(--c-primary);background:linear-gradient(135deg,rgba(30,136,229,.1),rgba(66,165,245,.1));padding:3px 10px;border-radius:100px;font-weight:600}
.sol-sb-daijia .bars{display:flex;align-items:flex-end;gap:6px;height:96px}
.sol-sb-daijia .bar{flex:1;border-radius:4px 4px 0 0;background:linear-gradient(180deg,#42a5f5,#1565c0);opacity:.9;transition:opacity .2s}
.sol-sb-daijia .bar:hover{opacity:1}
.sol-sb-daijia .bar.dim{background:linear-gradient(180deg,#cbd5e1,#94a3b8)}
.sol-sb-daijia .dash-float{position:absolute;background:#fff;border-radius:14px;box-shadow:0 14px 36px rgba(0,30,80,.25);padding:14px 18px;display:flex;align-items:center;gap:14px;animation:float 3.5s ease-in-out infinite;border:1px solid rgba(255,255,255,.6)}
.sol-sb-daijia .dash-float-1{top:-20px;right:-12px;animation-delay:0s}
.sol-sb-daijia .dash-float-2{bottom:-18px;left:-18px;animation-delay:1.5s}
.sol-sb-daijia .dash-float-icon{width:42px;height:42px;border-radius:12px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.sol-sb-daijia .dash-float-icon.green{background:linear-gradient(135deg,#d1fae5,#a7f3d0);color:#10b981}
.sol-sb-daijia .dash-float-icon.blue{background:linear-gradient(135deg,#dbeafe,#bfdbfe);color:#1e88e5}
.sol-sb-daijia .dash-float-text .num{font-size:1.05rem;font-weight:800;color:var(--c-text)}
.sol-sb-daijia .dash-float-text .label{font-size:.7rem;color:var(--c-slate-light)}
@keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}

.sol-sb-daijia .pain-section{background:linear-gradient(180deg,var(--c-white),var(--c-bg))}
.sol-sb-daijia .pain-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:28px}
.sol-sb-daijia .pain-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:36px 30px;transition:all .3s;position:relative;overflow:hidden}
.sol-sb-daijia .pain-card:hover{border-color:var(--c-primary-light);box-shadow:var(--shadow-xl);transform:translateY(-6px)}
.sol-sb-daijia .pain-card::before{content:"";position:absolute;top:0;left:0;right:0;height:4px;background:linear-gradient(90deg,#1e88e5,#42a5f5,#06b6d4);transform:scaleX(0);transform-origin:left;transition:transform .4s}
.sol-sb-daijia .pain-card:hover::before{transform:scaleX(1)}
.sol-sb-daijia .pain-num{position:absolute;top:24px;right:28px;font-size:2.8rem;font-weight:900;color:rgba(30,136,229,.06);line-height:1}
.sol-sb-daijia .pain-icon{width:56px;height:56px;border-radius:14px;background:linear-gradient(135deg,#e3f2fd,#bbdefb);display:flex;align-items:center;justify-content:center;margin-bottom:22px;box-shadow:0 8px 20px rgba(30,136,229,.15)}
.sol-sb-daijia .pain-icon svg{width:28px;height:28px;color:var(--c-primary-2)}
.sol-sb-daijia .pain-title{font-size:1.2rem;font-weight:700;color:var(--c-text);margin-bottom:12px}
.sol-sb-daijia .pain-desc{font-size:.92rem;color:var(--c-slate);line-height:1.8}

.sol-sb-daijia .solution-section{background:#fff}
.sol-sb-daijia .solution-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:28px}
.sol-sb-daijia .solution-card{background:linear-gradient(145deg,#f5f9ff,#e8f1fb);border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:40px 32px;transition:all .3s;position:relative;overflow:hidden}
.sol-sb-daijia .solution-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-4px)}
.sol-sb-daijia .solution-card::after{content:"";position:absolute;top:-30px;right:-30px;width:120px;height:120px;background:radial-gradient(circle,rgba(30,136,229,.1),transparent);pointer-events:none}
.sol-sb-daijia .solution-icon{width:52px;height:52px;border-radius:12px;background:linear-gradient(135deg,#1e88e5,#42a5f5);display:flex;align-items:center;justify-content:center;margin-bottom:22px;box-shadow:0 8px 20px rgba(30,136,229,.3)}
.sol-sb-daijia .solution-icon svg{width:26px;height:26px;color:#fff}
.sol-sb-daijia .solution-card h3{font-size:1.25rem;font-weight:700;color:var(--c-text);margin-bottom:14px}
.sol-sb-daijia .solution-card p{font-size:.95rem;color:var(--c-slate);line-height:1.8}

.sol-sb-daijia .func-section{background:linear-gradient(180deg,var(--c-bg),var(--c-white))}
.sol-sb-daijia .func-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:24px}
.sol-sb-daijia .func-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:36px 32px;transition:all .3s;position:relative;overflow:hidden;display:flex;gap:24px}
.sol-sb-daijia .func-card:hover{border-color:var(--c-primary-light);box-shadow:var(--shadow-lg);transform:translateY(-4px)}
.sol-sb-daijia .func-card::before{content:"";position:absolute;left:0;top:0;bottom:0;width:4px;background:linear-gradient(180deg,#1e88e5,#42a5f5);transform:scaleY(0);transform-origin:top;transition:transform .4s}
.sol-sb-daijia .func-card:hover::before{transform:scaleY(1)}
.sol-sb-daijia .func-card-num{font-size:2.4rem;font-weight:900;color:rgba(30,136,229,.12);line-height:1;flex-shrink:0;min-width:56px}
.sol-sb-daijia .func-card-body{flex:1}
.sol-sb-daijia .func-card-icon{width:44px;height:44px;border-radius:11px;background:linear-gradient(135deg,#e3f2fd,#bbdefb);display:flex;align-items:center;justify-content:center;margin-bottom:16px;box-shadow:0 4px 12px rgba(30,136,229,.12)}
.sol-sb-daijia .func-card-icon svg{width:22px;height:22px;color:var(--c-primary-2)}
.sol-sb-daijia .func-card-body h3{font-size:1.2rem;font-weight:700;color:var(--c-text);margin-bottom:10px}
.sol-sb-daijia .func-card-body p{font-size:.92rem;color:var(--c-slate);line-height:1.8}

.sol-sb-daijia .advantage-section{background:#fff}
.sol-sb-daijia .advantage-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px}
.sol-sb-daijia .advantage-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius);padding:34px 28px;transition:all .3s;position:relative;overflow:hidden}
.sol-sb-daijia .advantage-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-4px);border-color:var(--c-primary-light)}
.sol-sb-daijia .advantage-card::before{content:"";position:absolute;bottom:0;left:0;right:0;height:3px;background:linear-gradient(90deg,#1e88e5,#42a5f5);transform:scaleX(0);transform-origin:left;transition:transform .4s}
.sol-sb-daijia .advantage-card:hover::before{transform:scaleX(1)}
.sol-sb-daijia .advantage-icon{width:48px;height:48px;border-radius:12px;background:linear-gradient(135deg,#1e88e5,#42a5f5);display:flex;align-items:center;justify-content:center;margin-bottom:20px;box-shadow:0 6px 16px rgba(30,136,229,.25)}
.sol-sb-daijia .advantage-icon svg{width:24px;height:24px;color:#fff}
.sol-sb-daijia .advantage-card h3{font-size:1.12rem;font-weight:700;color:var(--c-text);margin-bottom:12px}
.sol-sb-daijia .advantage-card p{font-size:.9rem;color:var(--c-slate);line-height:1.75}

.sol-sb-daijia .scenario-section{background:linear-gradient(180deg,var(--c-bg),var(--c-bg-2))}
.sol-sb-daijia .scenario-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px}
.sol-sb-daijia .scenario-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius);padding:32px 28px;transition:all .3s;position:relative;overflow:hidden}
.sol-sb-daijia .scenario-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-4px);border-color:var(--c-primary-light)}
.sol-sb-daijia .scenario-tag{display:inline-block;padding:5px 12px;background:linear-gradient(135deg,rgba(30,136,229,.1),rgba(66,165,245,.1));color:var(--c-primary);font-size:.72rem;font-weight:700;border-radius:100px;margin-bottom:16px}
.sol-sb-daijia .scenario-card h3{font-size:1.1rem;font-weight:700;color:var(--c-text);margin-bottom:12px}
.sol-sb-daijia .scenario-card p{font-size:.9rem;color:var(--c-slate);line-height:1.75}
.sol-sb-daijia .scenario-card::after{content:"";position:absolute;bottom:-20px;right:-20px;width:80px;height:80px;background:radial-gradient(circle,rgba(30,136,229,.06),transparent);pointer-events:none}

.sol-sb-daijia .value-section{background:#fff}
.sol-sb-daijia .value-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:22px}
.sol-sb-daijia .value-card{background:linear-gradient(145deg,#f5f9ff,#e8f1fb);border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:36px 26px;text-align:center;transition:all .3s;position:relative;overflow:hidden}
.sol-sb-daijia .value-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-6px)}
.sol-sb-daijia .value-card::before{content:"";position:absolute;top:0;left:0;right:0;height:4px;background:linear-gradient(90deg,#1e88e5,#42a5f5,#06b6d4);transform:scaleX(0);transform-origin:center;transition:transform .4s}
.sol-sb-daijia .value-card:hover::before{transform:scaleX(1)}
.sol-sb-daijia .value-icon{width:56px;height:56px;border-radius:14px;background:linear-gradient(135deg,#1e88e5,#42a5f5);display:flex;align-items:center;justify-content:center;margin:0 auto 20px;box-shadow:0 8px 20px rgba(30,136,229,.3)}
.sol-sb-daijia .value-icon svg{width:28px;height:28px;color:#fff}
.sol-sb-daijia .value-card h3{font-size:1.1rem;font-weight:700;color:var(--c-text);margin-bottom:12px}
.sol-sb-daijia .value-card p{font-size:.88rem;color:var(--c-slate);line-height:1.75}
.sol-sb-daijia .value-highlight{display:inline-block;margin-top:14px;padding:5px 14px;background:#fff;border:1px solid var(--c-primary-light);border-radius:100px;font-size:.78rem;font-weight:700;color:var(--c-primary)}

.sol-sb-daijia .trust-section{background:linear-gradient(135deg,#0a3a7a 0%,#0d47a1 50%,#1565c0 100%);position:relative;overflow:hidden;padding:100px 0}
.sol-sb-daijia .trust-section::before{content:"";position:absolute;top:-50%;right:-10%;width:600px;height:600px;background:radial-gradient(circle,rgba(66,165,245,.15) 0%,transparent 70%);pointer-events:none}
.sol-sb-daijia .trust-section::after{content:"";position:absolute;bottom:0;left:0;right:0;height:1px;background:linear-gradient(90deg,transparent,rgba(255,255,255,.1),transparent)}
.sol-sb-daijia .trust-section .section-title{color:#fff}
.sol-sb-daijia .trust-section .section-subtitle{color:rgba(255,255,255,.7)}
.sol-sb-daijia .trust-section .section-num{color:#90caf9;background:rgba(255,255,255,.1)}
.sol-sb-daijia .trust-stats{display:grid;grid-template-columns:repeat(4,1fr);gap:24px;margin-bottom:60px}
.sol-sb-daijia .trust-stat{text-align:center;padding:36px 22px;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);border-radius:var(--radius);transition:.3s;backdrop-filter:blur(6px)}
.sol-sb-daijia .trust-stat:hover{background:rgba(255,255,255,.08);border-color:rgba(255,255,255,.18);transform:translateY(-6px)}
.sol-sb-daijia .trust-stat .num{font-size:2.8rem;font-weight:900;color:#fff;letter-spacing:-.025em;line-height:1;margin-bottom:8px}
.sol-sb-daijia .trust-stat .num .unit{font-size:1.4rem;font-weight:700}
.sol-sb-daijia .trust-stat .label{font-size:.88rem;color:rgba(255,255,255,.55);font-weight:500}
.sol-sb-daijia .logo-wall{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.1);border-radius:var(--radius-lg);padding:44px;margin-bottom:48px;backdrop-filter:blur(6px)}
.sol-sb-daijia .logo-wall-title{text-align:center;font-size:.82rem;color:rgba(255,255,255,.45);letter-spacing:.18em;text-transform:uppercase;margin-bottom:28px;font-weight:600}
.sol-sb-daijia .logo-grid{display:grid;grid-template-columns:repeat(6,1fr);gap:18px}
.sol-sb-daijia .logo-item{height:64px;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.08);border-radius:12px;display:flex;align-items:center;justify-content:center;font-size:.82rem;font-weight:700;color:rgba(255,255,255,.4);transition:.3s}
.sol-sb-daijia .logo-item:hover{background:rgba(255,255,255,.08);color:rgba(255,255,255,.8);border-color:rgba(255,255,255,.18);transform:translateY(-2px)}
.sol-sb-daijia .trust-cert{display:grid;grid-template-columns:repeat(3,1fr);gap:22px}
.sol-sb-daijia .cert-card{background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);border-radius:var(--radius);padding:28px;display:flex;align-items:center;gap:18px;transition:.3s;backdrop-filter:blur(6px)}
.sol-sb-daijia .cert-card:hover{background:rgba(255,255,255,.08);transform:translateY(-3px)}
.sol-sb-daijia .cert-icon{width:52px;height:52px;border-radius:12px;background:linear-gradient(135deg,rgba(66,165,245,.2),rgba(30,136,229,.2));display:flex;align-items:center;justify-content:center;flex-shrink:0;border:1px solid rgba(66,165,245,.3)}
.sol-sb-daijia .cert-icon svg{width:26px;height:26px;color:#90caf9}
.sol-sb-daijia .cert-info .title{font-size:.92rem;font-weight:700;color:#fff;margin-bottom:4px}
.sol-sb-daijia .cert-info .desc{font-size:.78rem;color:rgba(255,255,255,.45)}

.sol-sb-daijia .faq-section{background:linear-gradient(180deg,var(--c-bg),var(--c-white))}
.sol-sb-daijia .faq-wrap{max-width:880px;margin:0 auto}
.sol-sb-daijia .faq-item{border:1.5px solid var(--c-border);border-radius:var(--radius);margin-bottom:14px;overflow:hidden;transition:.3s;background:#fff}
.sol-sb-daijia .faq-item.active{border-color:var(--c-primary);box-shadow:0 8px 28px rgba(30,136,229,.12)}
.sol-sb-daijia .faq-item.active .faq-q{color:var(--c-primary)}
.sol-sb-daijia .faq-q{display:flex;align-items:center;justify-content:space-between;padding:22px 28px;cursor:pointer;font-size:1rem;font-weight:600;color:var(--c-text);transition:color .2s;user-select:none;gap:16px}
.sol-sb-daijia .faq-q .arrow{width:22px;height:22px;flex-shrink:0;transition:transform .3s;color:var(--c-slate-light)}
.sol-sb-daijia .faq-item.active .faq-q .arrow{transform:rotate(180deg);color:var(--c-primary)}
.sol-sb-daijia .faq-a{max-height:0;overflow:hidden;transition:max-height .4s ease}
.sol-sb-daijia .faq-a-inner{padding:0 28px 24px;font-size:.94rem;color:var(--c-slate);line-height:1.85}

.sol-sb-daijia .cta-section{position:relative;background:linear-gradient(135deg,#0d47a1 0%,#1565c0 50%,#1e88e5 100%);padding:100px 0;overflow:hidden}
.sol-sb-daijia .cta-section::before{content:"";position:absolute;top:0;left:0;right:0;bottom:0;background-image:radial-gradient(circle at 70% 30%,rgba(66,165,245,.25) 0%,transparent 50%),radial-gradient(circle at 20% 80%,rgba(255,255,255,.12) 0%,transparent 40%);pointer-events:none}
.sol-sb-daijia .cta-section::after{content:"";position:absolute;bottom:-1px;left:0;right:0;height:60px;background:linear-gradient(to bottom,transparent,var(--c-footer));pointer-events:none}
.sol-sb-daijia .cta-inner{position:relative;z-index:1;text-align:center;max-width:820px;margin:0 auto}
.sol-sb-daijia .cta-inner h2{font-size:2.5rem;font-weight:900;color:#fff;letter-spacing:-.025em;margin-bottom:20px;line-height:1.25}
.sol-sb-daijia .cta-inner h2 .highlight{background:linear-gradient(135deg,#fff,#bbdefb);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.sol-sb-daijia .cta-inner p{font-size:1.12rem;color:rgba(255,255,255,.8);line-height:1.85;margin-bottom:44px}
.sol-sb-daijia .cta-options{display:flex;gap:18px;justify-content:center;flex-wrap:wrap;margin-bottom:36px}
.sol-sb-daijia .cta-note{display:flex;align-items:center;justify-content:center;gap:10px;font-size:.85rem;color:rgba(255,255,255,.5);flex-wrap:wrap}
.sol-sb-daijia .cta-note .dot{width:5px;height:5px;background:rgba(255,255,255,.3);border-radius:50%}


.sol-sb-daijia .reveal{opacity:0;transform:translateY(32px);transition:opacity .8s ease,transform .8s ease}
.sol-sb-daijia .reveal.active{opacity:1;transform:translateY(0)}
.sol-sb-daijia .reveal-delay-1{transition-delay:.12s}
.sol-sb-daijia .reveal-delay-2{transition-delay:.24s}
.sol-sb-daijia .reveal-delay-3{transition-delay:.36s}

@media(max-width:1024px){
  .sol-sb-daijia .hero-grid{grid-template-columns:1fr;gap:48px}
  .sol-sb-daijia .hero h1{font-size:2.6rem}
  .sol-sb-daijia .pain-grid{grid-template-columns:repeat(2,1fr)}
  .sol-sb-daijia .solution-grid{grid-template-columns:1fr}
  .sol-sb-daijia .func-grid{grid-template-columns:1fr}
  .sol-sb-daijia .advantage-grid{grid-template-columns:repeat(2,1fr)}
  .sol-sb-daijia .scenario-grid{grid-template-columns:repeat(2,1fr)}
  .sol-sb-daijia .value-grid{grid-template-columns:repeat(2,1fr)}
  .sol-sb-daijia .trust-stats{grid-template-columns:repeat(2,1fr)}
  .sol-sb-daijia .logo-grid{grid-template-columns:repeat(3,1fr)}
}
@media(max-width:768px){
  .sol-sb-daijia .section{padding:72px 0}
  .sol-sb-daijia .section-title{font-size:1.8rem}
  .sol-sb-daijia .section-head{margin-bottom:42px}
  .sol-sb-daijia .nav{display:none}
  .sol-sb-daijia .header-cta .btn:not(.menu-toggle){display:none}
  .sol-sb-daijia .menu-toggle{display:flex}
  .sol-sb-daijia .nav.mobile-open{display:flex;position:absolute;top:72px;left:0;right:0;background:#fff;flex-direction:column;padding:24px;gap:20px;border-bottom:1px solid var(--c-border);box-shadow:var(--shadow-lg)}
  .sol-sb-daijia .nav.mobile-open a{font-size:1.05rem;padding:6px 0}
  .sol-sb-daijia .hero{padding:120px 0 64px}
  .sol-sb-daijia .hero h1{font-size:2.1rem}
  .sol-sb-daijia .hero-sub{font-size:1.05rem}
  .sol-sb-daijia .hero-cta{flex-direction:column;width:100%}
  .sol-sb-daijia .hero-cta .btn{width:100%}
  .sol-sb-daijia .hero-trust{gap:20px}
  .sol-sb-daijia .hero-trust-divider{display:none}
  .sol-sb-daijia .hero-trust-num{font-size:1.4rem}
  .sol-sb-daijia .hero-trust-label{font-size:.78rem}
  .sol-sb-daijia .hero-visual{max-width:440px;margin:0 auto}
  .sol-sb-daijia .dash-float{display:none}
  .sol-sb-daijia .pain-grid{grid-template-columns:1fr;gap:18px}
  .sol-sb-daijia .pain-card{padding:30px 24px}
  .sol-sb-daijia .func-card{padding:28px 24px;flex-direction:column;gap:16px}
  .sol-sb-daijia .func-card-num{font-size:2rem;min-width:auto}
  .sol-sb-daijia .advantage-grid{grid-template-columns:1fr}
  .sol-sb-daijia .scenario-grid{grid-template-columns:1fr}
  .sol-sb-daijia .value-grid{grid-template-columns:1fr 1fr}
  .sol-sb-daijia .trust-stats{grid-template-columns:1fr 1fr;gap:14px}
  .sol-sb-daijia .trust-stat{padding:24px 14px}
  .sol-sb-daijia .trust-stat .num{font-size:2.1rem}
  .sol-sb-daijia .logo-wall{padding:28px}
  .sol-sb-daijia .logo-grid{grid-template-columns:repeat(2,1fr);gap:14px}
  .sol-sb-daijia .logo-item{height:54px;font-size:.75rem}
  .sol-sb-daijia .trust-cert{grid-template-columns:1fr;gap:14px}
  .sol-sb-daijia .cert-card{padding:20px}
  .sol-sb-daijia .cta-inner h2{font-size:1.9rem}
  .sol-sb-daijia .cta-inner p{font-size:1rem}
  .sol-sb-daijia .cta-options{flex-direction:column;width:100%}
  .sol-sb-daijia .cta-options .btn{width:100%}
}
@media(max-width:480px){
  .sol-sb-daijia .container{padding:0 18px}
  .sol-sb-daijia .hero h1{font-size:1.85rem}
  .sol-sb-daijia .section-title{font-size:1.55rem}
  .sol-sb-daijia .dash-stats{grid-template-columns:1fr;gap:8px}
  .sol-sb-daijia .value-grid{grid-template-columns:1fr}
}
</style>
